/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';


export function ProfissionalCell({ rowData }) {
  const iniciais = rowData.Nome
    ?.split(' ')
    .slice(0, 2)
    .map((n) => n[0])
    .join('');

  const documento = rowData.cpf_cnpj;
  // const documento = rowData['cpf_cnpj'];

  const tipoDocumento =
    documento?.replace(/\D/g, '').length > 11
      ? 'CNPJ'
      : 'CPF';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}
    >
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          background: '#E8F0FE',
          color: '#2563eb',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 700,
          flexShrink: 0
        }}
      >
        {rowData.foto_perfil_caminho ? (
          <img
            src={rowData.foto_perfil_caminho}
            alt={rowData.Nome}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: '50%',
              background: '#E8F0FE',
              color: '#2563eb',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 700,
              flexShrink: 0
            }}
          />
        ) : (
          iniciais
        )}
      </div>

      <div>
        <div
          style={{
            fontWeight: 600
          }}
        >
          {rowData.Nome}
        </div>

        <div
          style={{
            fontSize: 12,
            // color: '#6b7280'
          }}
        >
          {/* Estado: {rowData.estado} */}
          <strong
            style={{
              fontWeight: 600,
              color: '#6b7280',
            }}
          >
            {tipoDocumento}:
          </strong>{' '}
          {documento}
        </div>

        <div
          style={{
            fontSize: 12,
            // color: '#9ca3af',
          }}
        >
          Estado: {rowData.estado}
          {/* <strong
            style={{
              fontWeight: 600,
              color: '#6b7280',
            }}
          >
            {tipoDocumento}:
          </strong>{' '}
          {documento} */}
        </div>
      </div>
    </div>
  );
}


ProfissionalCell.propTypes = {
  rowData: PropTypes.objectOf(PropTypes.any).isRequired,
};
